/** Apollo Client `fetchPolicy` values. */
export const APOLLO_FETCH_POLICY = {
  NETWORK_ONLY: 'network-only',
  CACHE_FIRST: 'cache-first',
  NO_CACHE: 'no-cache',
} as const;
